var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChnageHabits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 49.822 49.822",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line_Expand",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15742",
    "data-name": "Group 15742",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28215",
    "data-name": "Path 28215",
    d: "M46.265,11.033a1.545,1.545,0,1,0-2.913,1.033,21.058,21.058,0,0,1,1.264,7.183A21.6,21.6,0,0,1,23.037,40.826,21.352,21.352,0,0,1,8.009,34.661h4.239a1.541,1.541,0,1,0,0-3.083H4.541A1.546,1.546,0,0,0,3,33.12v7.707a1.541,1.541,0,0,0,3.083,0V37.081a24.341,24.341,0,0,0,16.955,6.828A24.694,24.694,0,0,0,47.7,19.248,24.394,24.394,0,0,0,46.265,11.033Z",
    transform: "translate(1.624 5.413)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28216",
    "data-name": "Path 28216",
    d: "M3.083,24.661A21.6,21.6,0,0,1,24.661,3.083,21.352,21.352,0,0,1,39.689,9.248H35.45a1.541,1.541,0,0,0,0,3.083h7.707A1.546,1.546,0,0,0,44.7,10.789V3.083a1.541,1.541,0,0,0-3.083,0V6.828A24.341,24.341,0,0,0,24.661,0,24.694,24.694,0,0,0,0,24.661a24.394,24.394,0,0,0,1.433,8.215,1.545,1.545,0,1,0,2.913-1.033,21.058,21.058,0,0,1-1.264-7.183Z",
    transform: "translate(0 0)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChnageHabits);
export default __webpack_public_path__ + "static/media/ChnageHabits.afb2b1ea506ceb3cf2d96c7acd19130c.svg";
export { ForwardRef as ReactComponent };